import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserMode, isGuest } from '../../../helpers/auth';
import { getProffitSearchValues } from '../../../helpers/profile';
import { scrollToWithHeaderHeight } from '../../../helpers/ScrollUtils';
import { useSlideSearchRegistration } from '../../../helpers/use/proffit_search/common/useSlideSearchRegistration';
import { useBoolState, useUnmountRef } from '../../../helpers/use/useHook';
import HubSpot from '../../../vendor/HubSpot';
import Layout from '../../Layout';
import SlideSearchRegistrationForm from '../../Ui/SlideSearch/Form/SlideSearchRegistrationForm';
import SlideSearchRegistrationCompleteModal from '../../Ui/SlideSearch/Modal/SlideSearchRegistrationCompleteModal';
import SlideSearchRegistrationModal from '../../Ui/SlideSearch/Modal/SlideSearchRegistrationModal';
import ProffitSearchLandingPageBeforeAfter from './Content/BeforeAfter';
import ProffitSearchLandingPageFooter from './Content/Footer';
import ProffitSearchLandingPageKeyVisual from './Content/KeyVisual';
import ProffitSearchLandingPagePlans from './Content/Plans';
import ProffitSearchLandingPageQuestions from './Content/Questions';
import ProffitSearchLandingPageSecurities from './Content/Securities';
import ProffitSearchLandingPageSteps from './Content/Steps';
import ProffitSearchLandingPageStickyColumn from './Content/StickyColumn';
import ProffitSearchLandingPageTeam from './Content/Team';
const ProffitSearchLandingPage = () => {
    const auth = useSelector((state) => state.auth);
    const profile = useSelector((state) => state.profile);
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const { boolState: isShowColumn, changeFalse: hideColumn } = useBoolState(true);
    const { canRegistrationTrial, enableProffitSearch, isEndTrial, plan } = useMemo(() => getProffitSearchValues(profile), [profile]);
    const userMode = getUserMode(auth);
    /**
     * 対象のElementまでスクロールさせる
     * @type {(function(*): void)|*}
     */
    const onClickScrollTo = useCallback((e) => {
        e.preventDefault();
        const { value } = e.currentTarget;
        scrollToWithHeaderHeight(value);
    }, []);
    const { email, hideCompleteModal, hideFormModal, initialValues, isShowCompleteModal, isShowFormModal, kanaRef, onSubmit, showFormModal, } = useSlideSearchRegistration.useSlideSearchRegistrationModal(profile, userMode, dispatch, unmountRef);
    // ゲスト、またはProffit Searchを利用していない会員の場合に登録モーダルを表示する
    const onClickCta = isGuest(auth) || !enableProffitSearch ? showFormModal : undefined;
    // HubSpotのチャットボット表示制御
    useEffect(() => {
        if (HubSpot.existsHubSpotConversations()) {
            // 読み込み後に表示
            HubSpot.loadChat();
        }
        else {
            // 読み込み自体が実行されていない場合、ロード後に表示する
            window.hsConversationsOnReady = [() => HubSpot.loadChat()];
        }
        return () => {
            // 離脱時に閉じる
            HubSpot.removeChat();
        };
    }, []);
    return (_jsxs(Layout, Object.assign({ footerClassName: 'footer_proffit_search_lp', headerType: 'none', isHideHelp: true, mainClassName: 'l-main layout_proffit_search_lp no-need-bottom-space', sticky: _jsx(ProffitSearchLandingPageStickyColumn, { hideColumn: hideColumn, isShow: isShowColumn }), stickyClassName: 'footer_proffit_search_lp_sticky' }, { children: [_jsx(ProffitSearchLandingPageKeyVisual, { isEndTrial: isEndTrial, plan: plan, showFormModal: showFormModal }), _jsx(ProffitSearchLandingPageBeforeAfter, {}), _jsx(ProffitSearchLandingPageSteps, { isEndTrial: isEndTrial, plan: plan, showFormModal: showFormModal }), _jsx(ProffitSearchLandingPageTeam, { isEndTrial: isEndTrial, plan: plan, showFormModal: showFormModal }), _jsx(ProffitSearchLandingPagePlans, { isEndTrial: isEndTrial, plan: plan, showFormModal: showFormModal }), _jsx(ProffitSearchLandingPageSecurities, {}), _jsx(ProffitSearchLandingPageQuestions, { enableProffitSearch: enableProffitSearch, onClickHelpLink: HubSpot.openChat, onClickScrollTo: onClickScrollTo, onClickTrialLink: onClickCta }), _jsx(ProffitSearchLandingPageFooter, { isEndTrial: isEndTrial, plan: plan, showFormModal: showFormModal }), _jsx(SlideSearchRegistrationModal, { formComponent: _jsx(SlideSearchRegistrationForm, { canRegistrationTrial: canRegistrationTrial, kanaRef: kanaRef, userMode: userMode }), hideModal: hideFormModal, initialValues: initialValues, isShow: isShowFormModal, onSubmit: onSubmit }), _jsx(SlideSearchRegistrationCompleteModal, { email: email, hideModal: hideCompleteModal, isShow: isShowCompleteModal })] })));
};
export default ProffitSearchLandingPage;
